/**
 * Hero Rooms Slider Component
 * Uses Swiper for slider functionality
 */

class HeroRoomsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
  }

  init() {
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not found');
      return;
    }

    const swiperContainer = this.querySelector('.hero-rooms-slider__slideshow');
    if (!swiperContainer) return;

    const prevButton = this.querySelector('.hero-rooms-slider__button--prev');
    const nextButton = this.querySelector('.hero-rooms-slider__button--next');
    const counterCurrent = this.querySelector('.hero-rooms-slider__counter-current');
    const autoRotate = swiperContainer.dataset.autoplay === 'true';
    const autoRotateSpeed = parseInt(swiperContainer.dataset.speed || '5') * 1000;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 500,
      autoplay: autoRotate ? {
        delay: autoRotateSpeed,
        disableOnInteraction: false,
      } : false,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        slideChange: (swiper) => {
          this.syncVideo(swiper, autoRotate);
          if (counterCurrent) {
            const realIndex = swiper.realIndex + 1;
            counterCurrent.textContent = realIndex.toString().padStart(2, '0');
          }
        },
      },
    });
    this.syncVideo(this.swiper, autoRotate);
  }

  syncVideo(swiper, autoRotate) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const activeVideo = swiper.slides[swiper.activeIndex]?.querySelector('.hero-rooms-slider__video');

    this.querySelectorAll('.hero-rooms-slider__video').forEach((video) => {
      if (video !== activeVideo || reduceMotion) {
        video.pause();
        video.currentTime = 0;
      }
    });

    if (activeVideo && !reduceMotion) {
      if (swiper.autoplay?.running) swiper.autoplay.stop();
      activeVideo.currentTime = 0;
      activeVideo.onended = () => {
        if (swiper.slides[swiper.activeIndex]?.contains(activeVideo) && autoRotate) {
          swiper.slideNext();
        }
      };
      activeVideo.play().catch(() => {
        if (autoRotate && swiper.autoplay && !swiper.autoplay.running) swiper.autoplay.start();
      });
    } else if (autoRotate && swiper.autoplay && !swiper.autoplay.running) {
      swiper.autoplay.start();
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Register custom element
if (!customElements.get('hero-rooms-slider')) {
  customElements.define('hero-rooms-slider', HeroRoomsSlider);
}